export default __webpack_public_path__ + "static/media/invoice.f03775a5.svg";